import { BookmarkRequest } from '@/domain/entities/bookmark/bookmarkRequest'
import { BookmarkRepository } from '@/domain/repositories/bookmark/bookmarkRepository'
import { Bookmark } from '@/domain/value_objects/bookmark/bookmark'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { bookmarkDecoder } from '@/infrastructure/decoders/bookmark/bookmarkDecoder'

export class BookmarkRepositoryImpl implements BookmarkRepository {
  constructor(private clients: ApiClients) {}

  async getBookmark(userId: string): Promise<Bookmark> {
    const path = `problems/bookmarks/users/${userId}`
    const data = await this.clients.aojClient.fetchAndDecode(bookmarkDecoder, path)
    return data
  }

  async postBookmark(problemId: string, userId: string): Promise<void> {
    const post: BookmarkRequest = {
      problemId: problemId,
      userId: userId
    }

    const path = `bookmarks`
    await this.clients.aojClient.fetch(path, {
      method: 'POST',
      body: JSON.stringify(post)
    })
  }

  async deleteBookmark(problemId: string, userId: string): Promise<void> {
    const post: BookmarkRequest = {
      problemId: problemId,
      userId: userId
    }

    const path = `bookmarks`
    await this.clients.aojClient.fetch(path, {
      method: 'DELETE',
      body: JSON.stringify(post)
    })
  }
}
